import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type Compliance = APIResponse<'/api/v4/compliances'>[number];

export const fetchCompliances = () => get<Compliance[]>('/v4/compliances');
